export default __webpack_public_path__ + "static/media/senor-evo.34aeb8b2.png";